var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 4.79999C2.3999 4.16347 2.65276 3.55303 3.10285 3.10294C3.55293 2.65285 4.16338 2.39999 4.7999 2.39999H12.7999C12.9485 2.39999 13.0941 2.44137 13.2205 2.51947C13.3469 2.59758 13.449 2.70934 13.5154 2.84222C13.5819 2.97511 13.61 3.12387 13.5967 3.27184C13.5833 3.41981 13.529 3.56114 13.4399 3.67999L11.3999 6.39999L13.4399 9.11999C13.529 9.23885 13.5833 9.38018 13.5967 9.52815C13.61 9.67612 13.5819 9.82488 13.5154 9.95776C13.449 10.0906 13.3469 10.2024 13.2205 10.2805C13.0941 10.3586 12.9485 10.4 12.7999 10.4H4.7999C4.58773 10.4 4.38425 10.4843 4.23422 10.6343C4.08419 10.7843 3.9999 10.9878 3.9999 11.2V13.6C3.9999 13.8122 3.91562 14.0157 3.76559 14.1657C3.61556 14.3157 3.41208 14.4 3.1999 14.4C2.98773 14.4 2.78425 14.3157 2.63422 14.1657C2.48419 14.0157 2.3999 13.8122 2.3999 13.6V4.79999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.3d04fec9bd7c8c2be8992bffd3523939.svg";
export { ForwardRef as ReactComponent };